import SessionStore from '../../../services/session/SessionStore'
export default function(angularModule) {
  angularModule.controller('adminUserInfoCtrl', function(
    $scope, $state, $uibModalInstance, users, billingAccount, userManagerService) {
      $scope.users = users;
      $scope.billingAccount = billingAccount;
      $scope.createUser = () => {
        $state.go('admin_v2.users_create', {
          accountId: billingAccount.primaryAccountId
        });
        $uibModalInstance.close()
      };
      $scope.editUser = (userId) => {
        $state.go('admin_v2.users_edit', {
          userId: userId
        });
        $uibModalInstance.close()
      };
      $scope.closeModal = () => $uibModalInstance.close();
      $scope.loginUser = SessionStore.impersonateUser
  })
};
